<mat-toolbar style="background-color: #fff; border-top: 1px solid #ddd; border-bottom: 1px solid #ddd;">
    <span>{{ sidebarTitle }}</span>
</mat-toolbar>
<div class="content">
    <div class="form">
        <div>
            <mat-form-field class="medium-field">
                <mat-label>Field Type</mat-label>
                <mat-select class="mat-primary" [(ngModel)]="selectedValue" (selectionChange)="onFieldTypeChanged()">
                    @for (fieldType of fieldTypes; track fieldType) {
                        <mat-option [class.selected]="fieldType === fieldForm.AttributeType"
                                    [value]="fieldType">
                            <span>{{fieldType}}</span>
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="state-validation-errors">{{fieldTypeError}}</div>
        <div class="state-validation-errors">{{errorString}}</div>
        <div>
            <mat-form-field class="medium-field">
                <mat-label>Field Id</mat-label>
                <input matInput [disabled]="editMode" (input)="validate('Field Id', fieldForm.AttributeId)" [(ngModel)]="fieldForm.AttributeId" value="" />
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="medium-field">
                <mat-label>Label</mat-label>
                <input matInput [disabled]="editMode" [(ngModel)]="fieldForm.AttributeName" value="" />
            </mat-form-field>
        </div>
        <div>
            <mat-form-field class="medium-field">
                <mat-label>Help Text</mat-label>
                <input matInput [disabled]="editMode" [(ngModel)]="fieldForm.HelpText" value="" />
            </mat-form-field>
        </div>
        <div>
            <mat-checkbox id="isMandatory" [(ngModel)]="fieldForm.IsMandatory" value="">Is Mandatory?</mat-checkbox>
        </div>
        @if (selectedValue === 'list') {
            <div>
                <div class="list-controls">
                    <br />
                    <mat-form-field class="medium-field">
                        <mat-label>List Alias</mat-label>
                        <mat-select matInput #listAliasFieldSelection="ngModel"
                                    [(ngModel)]="listAlias"
                                    id="listAliasSelector"
                                    required>
                            @for (list of lists; track list.Key) {
                                <mat-option [value]="list.Key"
                                            (click)="onListAliasClick()">
                                    {{list.FriendlyName}}
                                </mat-option>
                            }
                        </mat-select>
                        @if (listAliasFieldSelection.invalid) {
                            <mat-error>List source is required</mat-error>
                        }
                    </mat-form-field>
                    <div class="list-buttons">
                        <button mat-button
                                color="primary"
                                (click)="manageListItems()"
                                [disabled]="disableManageListItems()">
                            <mat-icon>list</mat-icon>
                            <span>Manage List Items</span>
                        </button>
                        <button mat-button
                                color="primary"
                                (click)="addList()">
                            <mat-icon>list</mat-icon>
                            <span>Add New List...</span>
                        </button>
                    </div>
                </div>
                <br />
            </div>
            <div>
                <mat-form-field class="medium-field">
                    <mat-label>Type of List</mat-label>
                    <mat-select #typeOfListSelection="ngModel"
                                class="mat-primary"
                                [(ngModel)]="isOfType"
                                required>
                        @for (isOfType of isOfTypes; track isOfType) {
                            <mat-option [value]="isOfType">
                                <span>{{isOfType}}</span>
                            </mat-option>
                        }
                    </mat-select>
                    @if (typeOfListSelection.invalid) {
                        <mat-error>List type is required</mat-error>
                    }
                </mat-form-field>
            </div>
        }
        @if (selectedValue === 'text') {
            <div>
                <mat-form-field class="medium-field">
                    <mat-label>Minimum Characters</mat-label>
                    <input matInput type="number" [(ngModel)]="fieldForm.MinChars" value="0">
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="medium-field">
                    <mat-label>Maximum Characters</mat-label>
                    <input matInput type="number" [(ngModel)]="fieldForm.MaxChars" value="0">
                </mat-form-field>
            </div>
            <div>
                <mat-checkbox id="isMultiline" [(ngModel)]="fieldForm.IsMultiLine" value="">Is Multiline?</mat-checkbox>
            </div>
        }
        @if (selectedValue === 'number') {
            <div>
                <mat-form-field class="medium-field">
                    <mat-label>Number Field Type</mat-label>
                    <mat-select class="mat-primary" [(ngModel)]="fieldForm.RegexRestrict" id="field-regex-restrict">
                        <mat-option [value]="unsignedIntegerInputRestriction" id="field-regex-restrict-unsigned-integer">
                            <span>Unsigned Integer</span>
                        </mat-option>
                        <mat-option [value]="signedIntegerInputRestriction" id="field-regex-restrict-signed-integer">
                            <span>Signed Integer</span>
                        </mat-option>
                        <mat-option [value]="unsignedDecimalInputRestriction" id="field-regex-restrict-unsigned-decimal">
                            <span>Unsigned Decimal</span>
                        </mat-option>
                        <mat-option [value]="signedDecimalInputRestriction" id="field-regex-restrict-signed-decimal">
                            <span>Signed Decimal</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        }
        @if (selectedValue === 'datetimepicker') {
            <div>
                <mat-checkbox id="hasTime" [(ngModel)]="fieldForm.HasTime" value="false">Include Time Fields?</mat-checkbox>
            </div>
        }
        @if (selectedValue === 'calc') {
            <div>
                <div>
                    <br />
                    <mat-form-field class="medium-field">
                        <mat-label>Parent Field</mat-label>
                        <mat-select [(ngModel)]="parentField" [compareWith]="compareSimpleFieldViewModels" (selectionChange)="getDrivingAttributes(parentField)">
                            @for (parentField of parentFields; track parentField.DisplayName) {
                                <mat-option [value]="parentField">
                                    {{parentField.DisplayName}}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div>
                <mat-form-field class="medium-field">
                    <mat-label>Driving Attribute</mat-label>
                    <mat-select class="mat-primary" [(ngModel)]="drivingAttribute">
                        @for (attribute of drivingAttributes; track attribute.Name) {
                            <mat-option [value]="attribute.Name">
                                {{attribute.Label}}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="medium-field">
                    <mat-label>Calculation Type</mat-label>
                    <mat-select class="mat-primary" [(ngModel)]="calculationType">
                        @for (calcType of calculationTypes; track calcType.Key) {
                            <mat-option [value]="calcType.Key">
                                {{calcType.Value}}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        }
        <br />
        <div>
            @if (!editMode) {
                <a mat-raised-button class="mat-accent" [disabled]="!validationPass() || isDisabled" (click)="validationPass() && saveField()">Save</a>
            } @else {
                <a mat-raised-button class="mat-accent" (click)="onUpdateFieldClick()">Update</a>
            }
        </div>
    </div>
</div>